import { Box, Card, Flex, Image } from '@energiebespaarders/symbols';
import mediaMin from '@energiebespaarders/symbols/styles/breakpoints';
import { themify } from '@energiebespaarders/symbols/styles/mixins';
import { rgba } from 'polished';
import styled from 'styled-components';

export const StyledPreTitle = styled.div`
  font-size: ${x => x.theme.type.scale[3]};
`;

export const StyledHero = styled(Box)<{ $version?: string; $bgColor?: string }>`
  background: ${x =>
    x.$version
      ? x.$version === 'A'
        ? x.theme.colors.gold
        : x.theme.colors.greenSlate
      : themify(x.$bgColor || 'greenSlate')};
  color: ${x => (x.$version === 'A' ? 'white' : 'grayDarker')};
`;

export const StyledTestimonialHero = styled(Flex)<{ bgPhoto: string; bgPosition: string }>`
  position: relative;
  min-height: 300px;
  background-size: cover;
  background-image: ${x =>
    `linear-gradient(rgba(255,255,255,0.25), rgba(255,255,255,1)), url(${x.bgPhoto})`};
  background-position: ${x => (x.bgPosition ? x.bgPosition : 'top 25%')} center;

  ${mediaMin.md} {
    min-height: 600px;
  }
`;

export const PlayCircle = styled.div`
  top: -22.5px;
  left: -30px;
  width: 75px;
  height: 75px;
  border: 3px solid rgba(255, 255, 255, 0.5);
  border-radius: 100px;
  background: ${x => rgba(x.theme.colors.green, 0.5)};
  transition: all 0.25s;

  ${mediaMin.md} {
    position: absolute;
    top: -45px;
    left: -62.5px;
    width: 150px;
    height: 150px;
  }
`;

export const PlayTriangle = styled.div`
  position: relative;
  top: -52px;
  left: 30px;
  width: 30px;
  height: 30px;
  border-top-right-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  text-align: left;
  transition: all 0.3s;
  transform: rotate(30deg) skewX(-30deg) scale(1, 0.866);

  ${mediaMin.md} {
    top: 0;
    left: 0;
    width: 60px;
    height: 60px;
  }

  &::before,
  &::after {
    position: absolute;
    width: 30px;
    height: 30px;
    border-top-right-radius: 6px;
    background: rgba(255, 255, 255, 0.75);
    content: '';

    ${mediaMin.md} {
      width: 60px;
      height: 60px;
    }
  }

  &::before {
    transition: all 0.15s;
    transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
  }

  &::after {
    transition: all 0.45s;
    transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
  }
`;

export const PlayButton = styled.div`
  position: absolute;
  top: calc(50% - 37.5px);
  left: calc(50% - 37.5px);
  cursor: pointer;

  ${mediaMin.md} {
    top: calc(50% - 30px);
    left: calc(50% - 30px);
  }

  &:hover {
    & ${PlayCircle} {
      border: 3px solid ${x => x.theme.colors.green};
      background: ${x => rgba(x.theme.colors.grayDarker, 0.25)};
    }

    & ${PlayTriangle} {
      background: ${x => rgba(x.theme.colors.green, 0.75)};

      &::before,
      &::after {
        background: ${x => rgba(x.theme.colors.green, 0.75)};
      }
    }
  }
`;

export const StyledMainQuote = styled.div`
  line-height: 1.25;
  font-weight: 500;
  font-family: ${x => x.theme.type.fontFamilySerif};
  font-size: ${x => x.theme.type.scale[2]};
  font-style: italic;
  text-align: center;
  color: ${x => x.theme.colors.grayBlack};
`;

export const StyledUsp = styled.h2`
  font-size: ${x => x.theme.type.scale[4]};
  margin: 0;
`;

export const MinimalNav = styled(Box)<{ $height: string; $zIndex?: number }>`
  position: relative;
  height: ${x => x.$height || x.theme.fixedSizes.navHeight};
  background: white;
  margin: 0 auto;
  text-align: center;
  border-bottom: 1px solid ${x => x.theme.colors.grayLight};
  z-index: ${x => x.$zIndex || 1};
`;

export const StyledLogo = styled(Image)`
  height: 100%;
`;

export const StyledCard = styled(Card)`
  text-align: center;
  width: 70%;
  color: ${x => x.theme.colors.grayBlack};
  box-shadow: 0 0 1px ${x => x.theme.colors.grayDark};
`;
export const StyledTagsTitle = styled.h4`
  color: ${x => x.theme.colors.grayDarker};
  font-size: ${x => x.theme.type.scale[4]};
`;
